import 'alpinejs';

window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');

// CoreUI
require('@coreui/coreui');

// Boilerplate
require('../plugins');

document.addEventListener('DOMContentLoaded', function () {
    var elements = document.getElementsByTagName('INPUT');
    var selects = document.getElementsByTagName('SELECT');
    for (var i = 0; i < elements.length; i++) {
        elements[i].oninvalid = function (e) {
            e.target.setCustomValidity('');
            if (!e.target.validity.valid) {
                e.target.setCustomValidity('Đây là trường bắt buộc');
            }
        };
        elements[i].oninput = function (e) {
            e.target.setCustomValidity('');
        };
    }

    for (var j = 0; j < selects.length; j++) {
        selects[j].oninvalid = function (e) {
            e.target.setCustomValidity('');
            if (!e.target.validity.valid) {
                e.target.setCustomValidity('Đây là trường bắt buộc');
            }
        };
        elements[j].oninput = function (e) {
            e.target.setCustomValidity('');
        };
    }
});
